<template>
	<div class="u_prf pt-2 pb-2">
		<b-overlay :show="module.is_load" rounded="sm">
			<div class="user_tabs">
				<b-tabs content-class="" class="nav-tabs-clean">
					<b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :disabled="tab.disabled" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
						<template slot="title">
							<div class="fs-lg px-4 pt-2">
                                <i class="fal text-primary pr-2" :class="tab.icon"></i>
                                {{get_tab_title(tab)}}
                                <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
							</div>
						</template>
                        <component v-bind:is="tab.index" :user="user"></component>
					</b-tab>
				</b-tabs>
			</div>
		</b-overlay>
	</div>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
	getterType: 'user/getUserField',
	mutationType: 'user/updateUserField',
});

import user_info from "./tabs/user_info";
import user_billing from "./tabs/user_billing";
import user_locales from "./tabs/user_locales";

export default {
	name: "profile",

	components : {
		user_info,
		user_billing,
        user_locales
	},

	data() {
		return  {
			is_load : false,
            is_profile_loaded : false,
			tabs:[]
		}
	},

	created() {
		EventBus.$on('user_added',this.load_full_profile);
        EventBus.$on('profile_loaded',this.load_user);

        if(!this.is_profile_loaded) {
            this.load_full_profile();
        }

	},
	methods : {
		async load_user() {
		    this.is_profile_loaded = true;
			this.tabs = [];
            this.push_tabs();
		},

        push_tabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    icon : item.icon,
                    title: item.title,
                    disabled: false,
                    is_active: item.is_active,
                    is_load: false,
                    index: item.index,
                    html: ''
                });
            });
        },

        async load_full_profile()
        {
            this.$store.dispatch('user/LOAD_FULL_USER');
        },

		get_tab_title (tab) {
			if(tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},

		set_active (obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}

			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},


	},

	computed : {
		...mapFields([
			'user',
			'module'
		]),

        default_tabs() {
            return [
                {
                    "icon" : "fa-user",
                    "title": this.__t('USER.PRFOILE'),
                    "index": "user_info",
                    is_active:true,
                },
                {
                    "icon" : "fa-light fa-globe",
                    "title": this.__t('USER.LOCALES'),
                    "index": "user_locales",
                    is_active:false,
                },
                {
                    "icon" : "fa-solid fa-money-bill",
                    "title": this.__t('USER.BILLING'),
                    "index": "user_billing",
                    is_active:false,
                },

            ]
        }
	}
}
</script>

<style scoped>

</style>
